import React from "react";
import {Grid} from "@material-ui/core";
import axios from "axios";
import {connect} from "react-redux";
import backgroundImage from "../../../assets/images/main_background.png";
import Toolbar from "../../Toolbar";
import SendIcon from "../../../assets/images/send_ic.png";
import HistoryImage from "../../../assets/images/img_history_variz.png";
import {data} from "../../../Store/Actions/DataAction";
import {free} from "../../../Store/Actions/FreeAction";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
import {avatarList, rollList, userData, walletHistory, walletReqPayHistory} from "../../../Utility/Url";
import Snackbar from "@material-ui/core/Snackbar";
import Item from "../../pageComponents/Settings/Item";
import contactUs from "../../../assets/images/contact_us.png";
import {withRouter} from "react-router-dom";
import conversation from "../../../assets/images/conversation.png";
import justice from "../../../assets/images/justice.png";
import privacy from "../../../assets/images/privacy.png";
import AvatarDialog from "../../pageComponents/Settings/AvatarDialog";
import ProfileDialog from "../../pageComponents/Settings/ProfileDialog";
import DialogContent from "@material-ui/core/DialogContent";
import {login} from "../../../Store/Actions/AuthActions";
import {act} from "@testing-library/react";
import style from "radium/es/components/style";

class FreePage extends React.Component {
    constructor(props) {
        super(props)
        this.state= {
            loading:true,
            allDataLoaded:false,
            res:null,
            id:null,
            open: false,
            hasBackButton:false,
            dialogHeight:'85%',
            dialogAlign:'flex-start',
            interval:'',
            vertical: 'bottom',
            horizontal: 'center',
            dialogBackgroundColor:'#3e0448',
            itemButton: {
                id:'contactUs',
                text:'...',
                icon:contactUs,
                textColor:'#ffffff',
                onClick:'contactUs'
            },
            snackMessage:'',
            style: {
                completed: 5,
                root: {
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor: "#810777",
                    // height: '100%',
                    overflow: 'hidden',
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0'
                },
            }
        }
    }
    // <p class="setting-support-question-detail"> append after temp.value
    //     ${new Date().toLocaleDateString('fa-IR')}
    // </p>
    fetchDialog=()=>{
        const {id} =this.state
        switch (id) {
            case 'contactUs':
                axios.get(`support/get`)
                    .then(res => {
                        const {data}=res
                        this.setState({
                            dialogHeight:'85%',
                            dialogAlign:'flex-start',
                            itemButton:{
                                id:'contactUs',
                                text:'ارتباط با ما',
                                icon:contactUs,
                                textColor:'#ffffff',
                                onClick:'contactUs'
                            }
                        },()=>{
                            this.setState({
                                res:data,
                                loading:false})
                        })
                    }).catch(error=>{
                        // console.log("failed")
                        // console.log(error.toString())
                    }
                )
                break
            case 'faq':
                axios.get(`app/faq`)
                    .then(res => {
                        const {data}=res
                        this.setState({
                            hasBackButton:true,
                            dialogHeight:'85%',
                            dialogAlign:'flex-start',
                            itemButton:{
                                id:'faq',
                                text:'سوالات متداول',
                                icon:conversation,
                                textColor:'#ffffff',
                                onClick:'faq'
                            }
                        },()=>{
                            this.setState({
                                res:data,
                                loading:false,
                            })
                        })
                    }).catch(error=>{
                        // console.log("failed")
                        // console.log(error.toString())
                    }
                )
                break
            case 'rule':
                axios.get(`app/rule`)
                    .then(res => {
                        const {data}=res
                        this.setState({
                            hasBackButton:true,
                            dialogHeight:'85%',
                            dialogAlign:'flex-start',
                            itemButton:{
                                id:'rules',
                                text:'قوانین',
                                icon:justice,
                                textColor:'#ffffff',
                                onClick:'rule'
                            }
                        },()=>{
                            this.setState({
                                res:data,
                                loading:false})
                        })
                    }).catch(error=>{
                        // console.log("failed")
                        // console.log(error.toString())
                    }
                )
                break
            case 'privacy' :
                axios.get(`app/privacy`)
                    .then(res => {
                        const {data}=res
                        this.setState({
                            hasBackButton:true,
                            dialogHeight:'85%',
                            dialogAlign:'flex-start',
                            itemButton:{
                                id:'privacy',
                                text:'حریم خصوصی',
                                icon:privacy,
                                textColor:'#ffffff',
                                onClick:'privacy'
                            }
                        },()=>{
                            this.setState({
                                res:data,
                                loading:false})
                        })
                    }).catch(error=>{
                        // console.log("failed")
                        // console.log(error.toString())
                    }
                )
                break
            case 'avatar' :
                axios.get(avatarList)
                    .then(res => {
                        const {data}=res
                        this.setState({
                            hasBackButton:true,
                            dialogHeight:'85%',
                            dialogAlign:'flex-start',
                            itemButton:{
                                id:'privacy',
                                text:'اواتار',
                                icon:'',
                                textColor:'#ffffff',
                                onClick:'privacy'
                            }
                        },()=>{
                            this.setState({
                                res:data,
                                loading:false})
                        })
                    }).catch(error=>{
                        // console.log("failed")
                        // console.log(error.toString())
                    }
                )
                break
            case 'wallethistory' :
                axios.get(walletHistory)
                    .then(res => {
                        const {data}=res
                        this.setState({
                            style: { ...this.state.style, root: { ...this.state.style.root , backgroundColor:'#01c89c'}},
                            dialogBackgroundColor:'rgb(24, 53, 73)',
                            dialogHeight:'85%',
                            dialogAlign:'flex-start',
                            itemButton:{
                                id:'privacy',
                                text:'تاریخچه واریز',
                                bgColor:'rgba(24, 53, 73,0.6)',
                                icon:HistoryImage,
                                textColor:'#ffffff',
                                onClick:'privacy'
                            }
                        },()=>{
                            this.setState({
                                res:data,
                                loading:false})
                        })
                    }).catch(error=>{
                        // console.log("failed")
                        // console.log(error.toString())
                    }
                )
                break
            case 'walletreqpayhistory' :
                axios.get(walletReqPayHistory)
                    .then(res => {
                        const {data}=res
                        this.setState({
                            style: { ...this.state.style, root: { ...this.state.style.root , backgroundColor:'#01c89c'}},
                            dialogBackgroundColor:'rgb(24, 53, 73)',
                            dialogHeight:'85%',
                            dialogAlign:'flex-start',
                            itemButton:{
                                id:'privacy',
                                text:'تاریخچه کیف پول',
                                icon:HistoryImage,
                                textColor:'#ffffff',
                                bgColor:'rgba(24, 53, 73,0.6)',
                                onClick:'privacy'
                            }
                        },()=>{
                            this.setState({
                                res:data,
                                loading:false})
                        })
                    }).catch(error=>{
                        // console.log("failed")
                        // console.log(error.toString())
                    }
                )
                break
            case 'profileedit' :
                this.setState({
                    dialogHeight:'60%',
                    dialogAlign:'center',
                    itemButton: {
                        id: 'privacy',
                        text: 'پروفایل',
                        icon: '',
                        textColor: '#ffffff',
                        onClick: 'privacy'
                    },
                    loading: false
                })
                break
            case 'support' :
                break
        }
    }
    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            const pathname =location.pathname
            const path = pathname.split("/")
            this.setState({
                loading:true
            },()=>{
                this.setData(path.pop())

            })
        });
    }
    setData=(id)=>{
        this.setState({
            id:id,
            // itemButton:itemData
        },()=>{
            this.props.toggleBottomNavbar()
            this.fetchData()
            this.fetchDialog()
            this.contactUs()
        })
    }
    async componentDidMount() {
        // const {itemData}=this.props.history.location.state
        const{id}=this.props.match.params
        console.log(this.props.match)
        this.setData(id)
    }
    handleSnack = (newState) => {
        this.setState({ open: true, ...newState },()=>{
            console.log(this.state)
        });
        setTimeout(()=>{
            this.setState({
                open:false
            })
        },2000)
    };
    addMessage=()=>{
        const temp = document.querySelector('#input')
        if (temp.value.length < 5){
            this.handleSnack({ vertical: 'bottom', horizontal: 'center',snackMessage:'پیام کوتاه است' })
        }
        else{
            let dat=document.getElementById('appendHere')
            let wrapper= document.createElement('div');
            wrapper.innerHTML= `<div class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end">
                    <p class="setting-support-question">
                     ${temp.value}
                       
                    </p>
                </div>`
            var div= wrapper.firstChild;
            dat.appendChild(div)
            temp.value=''
        }
    }
    fetchData= async()=>{
        await axios.get(userData)
            .then(res => {
                const {data}=res
                this.props.data(data)

                this.setState({
                    allDataLoaded:true
                })
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    contactUs = () => {
        console.log('begin',this.state)
        const {res, vertical, horizontal, open,snackMessage,hasBackButton}=this.state
        console.log('this is from render ',res)
        return (
            <Grid container alignItems={"center"} justify={"center"} style={{backgroundColor:'',height:'100%'}}>
                {
                    res &&
                    <Grid item container id='second' direction='column' style={{flex:'1',minHeight:'0',height:'100%'}}>
                        <Grid container alignItems={"flex-end"} style={{overflowY:'scroll',flex:'1',fontSize:'90%'}} id='appendHere'>
                            {
                                res.list.map(data=>
                                    <Grid  id={"me"} direction={"column"} container item>
                                        {
                                            data.answer &&

                                            <Grid justify={"flex-start"} container alignItems={"center"}>
                                                <p className='setting-support-answer'>
                                                    {data.text}
                                                </p>
                                            </Grid>
                                        }
                                        {
                                            !data.answer &&
                                            <Grid justify={"flex-end"} container alignItems={"center"}>
                                                <p className='setting-support-question' >
                                                    {data.text}
                                                    <p className='setting-support-question-detail'>
                                                        {data.timestamp}
                                                    </p>
                                                </p>
                                            </Grid>
                                        }
                                    </Grid>
                                )
                            }
                        </Grid>
                        <Grid justify={"center"} container id='toolbar' alignItems={"center"}>
                            <Grid className='setting-support-input-section'  container xs={11} sm={11} alignItems={"center"} justify={"center"}>
                                <Grid className='setting-support-input-section-image-holder clickable'
                                      justify={"center"}
                                      alignItems={"center"}
                                      container
                                      xs={1} sm={1}
                                      onClick={()=>{
                                          this.addMessage()
                                      }}
                                >
                                    <img src={SendIcon} style={{width:'100%'}} alt=""/>
                                </Grid>
                                <input id='input' type="text" style={{color:'#000000'}} maxLength={10} placeholder='پیغام خود را بنوسید'/>
                            </Grid>
                        </Grid>

                    </Grid>
                }
            </Grid>
        )
    }
    faq = () => {
        const {res, vertical, horizontal, open,snackMessage }=this.state
        return (
            <Grid container direction={"column"} id="second" style={{flex: '1 1 0%', overflowYy: 'scroll', minHeight: '0px', height: '100%'}}>
                <Grid class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end" id="appendHere"
                      style={{flex: '1 1 0%', overflowY: 'scroll', minHeight: '0px'}}>
                    {res.list.map(data =>
                        <Grid container id="me">
                            <Grid container alignItems={"center"} justify={"flex-end"}>
                                <p className="setting-faq-question" style={{backgroundColor: "green"}}>
                                    {data.question}
                                </p>
                            </Grid>
                            <Grid container alignItems={"center"}
                                  class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center">
                                <p className="setting-faq-answer" style={{backgroundColor: 'yellow'}}>
                                    {data.answer}
                                </p>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        )
    }
    privacy = () => {
        const {res}=this.state
        return (
            <Grid container direction={"column"} id="second" style={{flex: '1 1 0%', minHeight: '0px', height: '100%'}}>
                <Grid class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end" id="appendHere"
                      style={{flex: '1 1 0%', overflowY: 'scroll', minHeight: '0px'}}>
                    <Grid container xs={12} className='setting-privacy'
                          style={{
                              alignSelf: 'flex-start',color: '#ffffff'
                          }}
                    >
                        <p>
                            {res.text}
                        </p>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
    rule = () => {
        const {res, vertical, horizontal, open,snackMessage }=this.state
        return (
            <Grid container direction={"column"} id="second" style={{flex: '1 1 0%', overflowYy: 'scroll', minHeight: '0px', height: '100%'}}>
                <Grid class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end" id="appendHere"
                      style={{flex: '1 1 0%', overflowY: 'scroll', minHeight: '0px'}}>
                    {res.list.map(data =>
                        <Grid container className='setting-rules'
                            style={{padding:'0 0 0 10px'}}
                        >
                            <ul>
                                <li>
                                    {data.title}
                                </li>
                                <p>
                                    {data.text}
                                </p>
                            </ul>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        )
    }
    avatar = () => {
        const {res, vertical, horizontal, open,snackMessage,loading,allDataLoaded }=this.state
        console.log(this.state)
        return (
            <>
                {
                    (allDataLoaded) &&
                    <AvatarDialog closeDialog={()=>{}} avatars={res}/>
                }
            </>
        )
    }
    profileedit = () => {
        const {res, vertical, horizontal, open,snackMessage,loading,allDataLoaded }=this.state
        console.log(this.state)
        return (
            <>
                {
                    (allDataLoaded) &&
                    <ProfileDialog closeDialog={()=>{}}/>
                }
            </>
        )
    }
    wallethistory = () => {
        const {res, vertical, horizontal, open,snackMessage,loading,allDataLoaded }=this.state
        console.log(this.state)
        return (
            <>
                {
                    (allDataLoaded) &&
                    <Grid  container direction={"column"} id="second" style={{flex: '1 1 0%', overflowYy: 'scroll', minHeight: '0px', height: '100%'}}>
                        <Grid class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end" id="appendHere"
                              style={{flex: '1 1 0%', overflowY: 'scroll', minHeight: '0px'}}>
                            {res.list.map(data =>
                                <Grid
                                    className="MuiGrid-root wallet-button-content-message MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center"
                                    style={{margin:'10px 0px',backgroundColor:data.value<'0'?'red':'green'}}
                                >
                                    <Grid
                                        className="MuiGrid-root wallet-button-content-message-inner MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-12 MuiGrid-grid-sm-12">
                                        <Grid
                                            className="MuiGrid-root wallet-button-content-message-inner-title MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5"
                                            style={{backgroundColor:data.value  <'0' ?'red':'green'}}
                                        >
                                            <p>{data.timestamp}</p>
                                        </Grid>
                                        <Grid className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7">

                                        </Grid>
                                        <Grid className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7">
                                        </Grid>
                                        <Grid
                                            className="MuiGrid-root wallet-button-content-message-inner-description MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5">
                                            <p>{data.description}</p>
                                        </Grid>
                                        <Grid
                                            className="MuiGrid-root wallet-button-content-message-inner-price-text MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5">
                                            <Grid
                                                className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end">
                                                <p>مبلغ</p>
                                            </Grid>
                                            <Grid
                                                className="MuiGrid-root wallet-button-content-message-inner-price MuiGrid-container MuiGrid-item MuiGrid-justify-xs-center">
                                                <p>{data.value}</p>
                                            </Grid>
                                        </Grid>
                                        <Grid className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7">

                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                }
            </>
        )
    }
    walletreqpayhistory = () => {
        const {res, vertical, horizontal, open,snackMessage,loading,allDataLoaded }=this.state
        console.log(this.state)
        return (
            <>
                {
                    (allDataLoaded) &&
                    <Grid  container direction={"column"} id="second" style={{flex: '1 1 0%', overflowYy: 'scroll', minHeight: '0px', height: '100%'}}>
                        <Grid class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-flex-end" id="appendHere"
                              style={{flex: '1 1 0%', overflowY: 'scroll', minHeight: '0px'}}>
                            {res.list.map(data =>
                                <Grid
                                    className="MuiGrid-root wallet-button-content-message MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center"

                                    style={{
                                        margin:' 10px 0px',
                                        backgroundColor:  data.status=='0'?'orange': data.status=='1'?'green': data.status=='-1'?'red':'red'
                                    }}
                                >
                                    <Grid
                                        className="MuiGrid-root wallet-button-content-message-inner MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-12 MuiGrid-grid-sm-12">
                                        <Grid
                                            className="MuiGrid-root wallet-button-content-message-inner-title MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5"
                                            style={{
                                                backgroundColor:  data.status=='0'?'orange': data.status=='1'?'green': data.status=='-1'?'red':'red'
                                            }}
                                        >
                                            <p>{data.date}</p>
                                        </Grid>
                                        <Grid
                                            className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7"></Grid>
                                        <Grid
                                            className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7">
                                        </Grid>
                                        <Grid
                                            className="MuiGrid-root wallet-button-content-message-inner-description MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5">
                                            <p>{data.desc}</p>
                                        </Grid>
                                        <Grid
                                            className="MuiGrid-root wallet-button-content-message-inner-price-text MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-center MuiGrid-grid-xs-5 MuiGrid-grid-sm-5">
                                            <Grid
                                                className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end">
                                                <p>مبلغ</p>
                                            </Grid>
                                            <Grid
                                                className="MuiGrid-root wallet-button-content-message-inner-price MuiGrid-container MuiGrid-item MuiGrid-justify-xs-center">
                                                <p>{data.reqValue}</p>
                                            </Grid>
                                        </Grid>
                                        <Grid className="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-grid-xs-7 MuiGrid-grid-sm-7"></Grid>
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                }
            </>
        )
    }
    // walletreqpayhistory = () => {
    //     const {res, vertical, horizontal, open,snackMessage,loading,allDataLoaded }=this.state
    //     console.log(this.state)
    //     return (
    //         <>
    //             {
    //                 (allDataLoaded) &&
    //                 <ProfileDialog closeDialog={()=>{}}/>
    //             }
    //         </>
    //     )
    // }
    render() {
        const item={
            id:'contactUs',
            text:'ارتباط با ما',
            icon:contactUs,
            textColor:'#ffffff',
            onClick:'contactUs'
        }
        const backButton={
            id:'',
            text:'بازگشت',
            icon:'',
            textColor:'#ffffff',
            onClick:''
        }
        const {res,hasBackButton,vertical, horizontal, open,snackMessage,id,itemButton,dialogHeight, dialogAlign,dialogBackgroundColor }=this.state

        return(
            <Grid direction={"column"} justify={"center"} alignItems={"center"} item container style={this.state.style.root}>
                <Grid item sm={12} xs={12} justify={'center'} container alignItems={"center"}
                      style={{flex:'1',minHeight:'0'}}>
                    <Grid item container>
                        <Toolbar type='sideToolbar'/>
                    </Grid>
                    <Grid container
                          justify={"center"}
                          alignItems={dialogAlign}
                          style={{
                              height:'89%',
                              flex:'1 1 0% !important',
                          }}
                    >
                        <Grid container direction={"column"} sm={10} xs={10} alignItems={'center'} justify={"flex-start"}
                              style={{backgroundColor:dialogBackgroundColor,position:'relative',borderRadius:'18px',border:'2px solid gray',height:dialogHeight}}>
                            <Grid alignItems={"center"} justify={"center"} container>
                                <Item data={itemButton}/>
                            </Grid>
                            <Grid  alignItems={"center"} justify={"center"} container
                                   style={{background:'',maxHeight:'70%',flex:'1',margin:'auto'}}>
                                {
                                    !this.state.loading &&
                                    <>
                                        {this[id]()}
                                    </>
                                }
                                {
                                    hasBackButton &&
                                    <Grid xs={6} container alignItems={"center"} justify={"center"}
                                          className='setting-dialog-button'
                                          onClick={()=>{
                                              this.props.history.push('/settings')
                                          }}
                                    >
                                        <Item data={backButton}/>
                                    </Grid>
                                }


                                {
                                    this.state.loading &&
                                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                          style={{position:'relative'}}
                                    >
                                        <Grid item container justify={"center"} style={{position:'absolute'}}>
                                            <PicoLoader/>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                            <Snackbar
                                anchorOrigin={{ vertical, horizontal }}
                                open={open}
                                message={snackMessage}
                                key={vertical + horizontal}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
const mapStateToProps=state=>({
    UserData:state.UserData,
    Free:state.Free
})
export default connect(mapStateToProps,{data,free})(withRouter(FreePage))